import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-tile',
  template: `
    <h1 *ngIf="heading" class="border-b">{{ heading }}</h1>
    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        display: block;
        margin: theme('margin.10') theme('margin.8');
        @apply px-8 py-8 border border-transparent shadow-2xl bg-white rounded-2xl;
      }

      h1 {
        font-size: theme('fontSize.xl');
        font-weight: theme('fontWeight.semibold');
        margin: 0 -2rem;
        padding-left: 2rem;
        padding-bottom: 2rem;
      }
    `,
  ],
})
export class SectionTileComponent {
  @Input() public heading!: string;
}
